<template>
  <div ref="container" class="container">
    <Header/>
    <Banner/>
    <template v-if="$skillType===2">
      <GoodsVirtual/>
      <GoodsEntity/>
    </template>
    <template v-if="$skillType===3">
<!--      <GoodsEntity/>-->
      <GoodsEntity/>
    </template>
    <template v-if="$skillType===4">
<!--      <GoodsVirtual/>-->
      <GoodsVirtual/>
    </template>
  </div>
</template>

<script>
import axios from "axios";
import {debounce} from "lodash";
import Header from "./components/Header";
import Banner from "./components/Banner";
import GoodsVirtual from "./components/GoodsVirtual";
import GoodsEntity from "./components/GoodsEntity";
// import Footer from "./components/Footer.vue";

import VConsole from "vconsole";
// ;

export default {
  name: "Home",
  components: {
    Header,
    Banner,
    GoodsEntity,
    GoodsVirtual,
    // Footer,
  },
  data() {
    return {};
  },
  methods: {
    async finishTask() {
      const {data: res} = await finishTask({
        m2oId: this.$store.state.nthUserInfo.userid,
      });
      if (res.code == 200) {
        if (res.data) {
          SmartCity.creditRulesUpdate({
            availableScore: res.data.availableScore,
          });
          this.toast(res.data.message);
        }

        // this.getFavoriteServeList()
      }
    },
  },
  created() {

  },
};
</script>
<style lang="less" scoped>
.container {
  width: 100%;

  height: calc(100vh - 70px);
  overflow-y: scroll;

  background: #f4f4f4;
  // background: chocolate;

  .swipe-wrap {
    height: calc(100vh - 310px);

    .van-swipe {
      height: 100%;
    }

    /deep/ .van-swipe__track--vertical {
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
      -webkit-flex-direction: column;
      flex-direction: column;
      // height: calc(100vh - 400px) !important;
    }

    /deep/ .van-swipe__track {
      display: -webkit-box;
      display: -webkit-flex;
      display: flex;
      // height: calc(100vh - 400px) !important;
    }

    /deep/ .van-swipe-item {
      width: 100%;
      height: 100% !important;
      padding: 10px;
      overflow: hidden;
    }
  }

  .goods {
    // padding: 10px;
    background: #fff;
    border-radius: 7px;
    margin: 15px;

    .top {
      // height: 80%;

      img {
        width: 100%;
        height: 300px;
        border-radius: 7px 7px 0 0;
      }
    }

    .bottom {
      // flex: 1;
      // height: 20%;
      padding: 15px;

      .name {
        font-size: 16px;
        font-weight: bold;
      }

      .price {
        color: #f85f3b;

        font-size: 16px;
        font-weight: bold;
        padding: 10px 0;

        span:nth-child(2) {
          font-size: 12px;
          color: #999;
          margin: 4px 0;
        }
      }

      .btns {
        display: flex;

        /****按钮固定****/
        /* position: fixed;
         width: 98%;
         bottom: 50px;
         left: 50%;
         transform: translateX(-50%);*/
        /****按钮固定****/

        justify-content: flex-end;
        align-items: center;

        .btn {
          padding: 4px 10px;
          border-radius: 20px;
          background: #ff7b07;
          color: #fff;
        }
      }
    }
  }
}

/deep/ .van-toast {
  z-index: 99999;
}

.grey {
  background: #eee;
}

.container::-webkit-scrollbar {
  display: none;
}
</style>
